export default "__VITE_ASSET__DZbO5vnB__"